module.exports = __webpack_public_path__ + "static/media/loginBG.9815743c.jpg";